import { FC, useMemo } from "react";
import { SxProps } from "@mui/material";
import { RegisterUserPrivacyPolicy } from "./RegisterUserPrivacyPolicy";
import { CriiptoVerifyProvider } from "@criipto/verify-react";
import { RegisterUserProcess } from "./RegisterUserProcess";
import { RegisterUserOAuthError } from "./RegisterUserOAuthError";

export interface RegisterUserProps {
  sx?: SxProps;
}

export const RegisterUser: FC<RegisterUserProps> = (props) => {
  const urlParams = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      code: params.get("code"),
      error: params.get("error"),
      errorDescription: params.get("error_description"),
    };
  }, []);

  const redirectUri = useMemo(() => {
    const loc = window.location;
    return `${loc.protocol}//${loc.hostname}:${
      loc.port === "80" ? "" : loc.port
    }/register-user`;
  }, []);

  const handleCancel = () => {
    window.location.href = "/";
  };

  const hasOAuthError = urlParams.error != null;
  const hasCode = urlParams.code != null;

  return (
    <CriiptoVerifyProvider
      domain="identification.airmontcloud.net"
      clientID="urn:my:application:identifier:187756"
      redirectUri={redirectUri}
    >
      {hasOAuthError && <RegisterUserOAuthError />}
      {!hasOAuthError && !hasCode && (
        <RegisterUserPrivacyPolicy sx={props.sx} onCancel={handleCancel} />
      )}
      {!hasOAuthError && hasCode && <RegisterUserProcess sx={props.sx} />}
    </CriiptoVerifyProvider>
  );
};
